var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-insp",class:{
    'active': _vm.isActive,
    'all': _vm.all,
    'circle': !_vm.textBtn && _vm.isCircle,
    'triangle': !_vm.textBtn && _vm.isTriangle,
    'cross': !_vm.textBtn && _vm.isCross,
    'low': _vm.textBtn == '低',
    'mid': _vm.textBtn == '中',
    'high': _vm.textBtn == '高',
    'btn-insp el-button btn-work el-button--default w100i': _vm.isOsusume,
    'green': _vm.isOsusume && _vm.isActive,
    'normal bold': _vm.isOsusume && !_vm.isActive},on:{"click":_vm.onClick}},[(!_vm.textBtn && _vm.isCross)?_c('i',{staticClass:"el-icon-close"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.textBtn))])])}
var staticRenderFns = []

export { render, staticRenderFns }